module.exports = __webpack_public_path__ + "img/zip.d32dcd6e.svg";